import * as React from 'react';
import * as Classes from '../common/classes';
import classNames from 'classnames';
import { Icon } from '../icon/Icon';
import { mcFilterRange } from '@mc/react-ui-icons';

type Props = {
  className?: string;
  centerValues?: boolean;
  children?: React.ReactNode;
};

export const InputRange: React.FC<Props> = ({
  className,
  children,
  centerValues,
}) => {
  const items: any = [];
  React.Children.forEach(children, (child) => {
    items.push(child);
  });
  return (
    <div
      className={classNames(Classes.INPUT_RANGE, className, {
        [Classes.INPUT_RANGE_CENTER_VALUES]: centerValues,
      })}
    >
      {items[0]}
      <Icon className={Classes.INPUT_RANGE_ICON} icon={mcFilterRange} />
      {items[1]}
    </div>
  );
};
